import { render, staticRenderFns } from "./EditPolicyModal.vue?vue&type=template&id=738d8b03"
import script from "./EditPolicyModal.vue?vue&type=script&lang=js"
export * from "./EditPolicyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports